export enum ToastrVariant {
    Success = 'success',
    Error = 'danger',
    Warning = 'warning'
}